module.exports = {"450602001":"渔州坪街道","450602002":"白沙万街道","450602003":"沙潭江街道","450602004":"王府街道","450602100":"企沙镇","450602101":"光坡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450602.json
// module id = 1946
// module chunks = 0